import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AppBar from 'material-ui/AppBar';
import AuthService from '../../services/AuthService';
import LoginForm from '../../components/Login';

export class Login extends Component {
  static propTypes = {
    location: PropTypes.object,
    auth: PropTypes.instanceOf(AuthService)
  }

  state = {
    error: null
  }

  login = (values) => {
    const { email, password } = values;

    this.props.auth.login(email, password, this.props.dispatch).then((response) => {
      if (response.status === 401) {
        const error = 'Invalid login credentials';
        this.setState({ error });
      }
    }).catch((e) => {
      const error = 'Error logging in';
      this.setState({ error });
    });
  }

  render() {
    const { error } = this.state;
    return (
      <div>
        <AppBar title="Access" showMenuIconButton={false} />
        <div className="row">
          <div className="col s12">
            <LoginForm onSubmit={this.login} _error={error} />
          </div>
        </div>
      </div>
    )
  }
}

export default connect()(Login);


// WEBPACK FOOTER //
// ./src/containers/Login/index.js